import { IRootState } from '../../../store'
import { IAuthorizationInformationOptionState } from '../store/options.types'

export const getAuthorizationInformationOptionsSelector = (state: IRootState): IAuthorizationInformationOptionState =>
  state.options.authorizationInformationOptions
